$(document).ready(function(){

		$('[data-component="banner-section"] a').on('mouseenter', function(){
			$(this).children('a i').attr('class', 'icon-arrow-right-white');
		}).on('mouseleave', function(){
			$(this).children('a i').attr('class', 'icon-arrow-right');
		})

		var imageMobile = $('.full-banner-holder').data('mobile-background');
		if($(window).width() < 580){
			$('.full-banner-holder').attr('style', 'background-image: url( ' + imageMobile +' ); background-position: bottom right;');
		}


	});
